import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { V2_AUTH_STORAGE_KEY } from '../persistence/persistenceContract';

// Backend adapter: TRUE V2 reuses the production Supabase *service* by contract, never the
// legacy client implementation. Two deliberate differences from the legacy app:
//   - auth.storageKey is pinned to yanwushi-v2-auth, so this client can never pick up the
//     session the legacy app stored under the SDK's default sb-<ref>-auth-token key;
//   - when env is absent the adapter stays null and the app runs local-only (closed door,
//     no half-configured network paths).
const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim();
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim();

const client: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          storageKey: V2_AUTH_STORAGE_KEY,
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: false
        }
      })
    : null;

export function getSupabase(): SupabaseClient | null {
  return client;
}

export function backendConfigured(): boolean {
  return client !== null;
}
